import { APPLICATION_ROUTES } from "../../utils/routes";
import type { AdminNavItem, ProfileNavItem } from "./nav_item.types";
import {
	AdminPageUsersIcon,
	AdminPageFeedbacksIcon,
} from "../../assets/icons/admin_page_icons/admin_page_sidebar_icons";
import MentorshipIcon from "../../assets/icons/user_profile_page_icons/mentorship_icon";
// Phosphor glyphs, matching the designer's prototype. Items the prototype has no
// counterpart for keep the icon they had.
import {
	ChalkboardTeacherIcon,
	ChartLineUpIcon,
	HouseIcon,
	NoteIcon,
	PulseIcon,
	QuestionIcon,
	UsersThreeIcon,
} from "@phosphor-icons/react";

export const PROFILE_LINKS: ProfileNavItem[] = [
	{
		key: "profile-activity",
		path: APPLICATION_ROUTES.PROFILE_ACTIVITY,
		icon: PulseIcon,
		textKey: "app-header.sidebar.profile.activity",
	},
	{
		key: "profile-questions",
		path: APPLICATION_ROUTES.PROFILE_QUESTIONS,
		icon: QuestionIcon,
		textKey: "app-header.sidebar.profile.questions",
	},
	{
		key: "profile-notes",
		path: APPLICATION_ROUTES.PROFILE_NOTES,
		icon: NoteIcon,
		textKey: "app-header.sidebar.profile.notes",
	},
	{
		key: "profile-mentorship",
		path: APPLICATION_ROUTES.PROFILE_MENTORSHIP,
		icon: MentorshipIcon,
		textKey: "app-header.sidebar.profile.mentorship",
		mentorOnly: true,
	},
];

export const ADMIN_LINKS: AdminNavItem[] = [
	{
		key: "admin-home",
		path: APPLICATION_ROUTES.ADMIN_HOME,
		icon: HouseIcon,
		textKey: "app-header.sidebar.admin.home",
		requiredAccess: ["isSuperadmin", "isAdminOfPlatformHomePage"],
	},
	{
		key: "admin-courses",
		path: APPLICATION_ROUTES.ADMIN_COURSES,
		icon: ChalkboardTeacherIcon,
		textKey: "app-header.sidebar.admin.courses",
		requiredAccess: ["isSuperadmin", "isAdminOfCourses", "isAdminOfPlatformCourses", "isAuthor"],
	},
	{
		key: "admin-groups",
		path: APPLICATION_ROUTES.ADMIN_GROUPS,
		icon: UsersThreeIcon,
		textKey: "app-header.sidebar.admin.groups",
		requiredAccess: ["isSuperadmin", "isAdminOfGroups", "isAdminOfPlatformGroups", "isAuthor"],
	},
	{
		key: "admin-questions",
		path: APPLICATION_ROUTES.ADMIN_QUESTIONS,
		icon: QuestionIcon,
		textKey: "app-header.sidebar.admin.questions",
		requiredAccess: [
			"isSuperadmin",
			"isAdminOfPlatformQuestions",
			"isAuthor",
			"isCourseFeedbackRecipient",
			"isOperatorOfSupport",
		],
	},
	{
		key: "admin-users",
		path: APPLICATION_ROUTES.ADMIN_USERS,
		icon: AdminPageUsersIcon,
		textKey: "app-header.sidebar.admin.users",
		requiredAccess: ["isSuperadmin", "isAdminOfPlatformUsers"],
	},
	{
		key: "admin-analytics",
		path: APPLICATION_ROUTES.ADMIN_ANALYTICS,
		icon: ChartLineUpIcon,
		textKey: "app-header.sidebar.admin.analytics",
		requiredAccess: ["isSuperadmin", "isAdminOfPlatformAnalytics"],
	},
	{
		key: "admin-feedbacks",
		path: APPLICATION_ROUTES.ADMIN_FEEDBACKS,
		icon: AdminPageFeedbacksIcon,
		textKey: "app-header.sidebar.admin.feedbacks",
		requiredAccess: [
			"isSuperadmin",
			"isAdminOfPlatformAnalytics",
			"isAdminOfPlatformCourses",
			"isAdminOfCourses",
		],
	},
];
